export enum enumPacks {
  pro = "PRO",
  base = "ESSENTIALS",
  enterprise = "ENTERPRISE",
}
